import React, { useState, useEffect } from 'react';
import ShiftExtensionAlert from './ShiftExtensionAlert';
import ShiftExtensionRequestModal from './ShiftExtensionRequestModal';
import { callApi } from '../../utils/api';
import { toast } from "react-toastify";
import isEmpty from 'lodash/isEmpty';

export default function ShiftExtensionWrapper({ userShiftEndTime }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [alertClose, setAlertClose] = useState(false);
  const [requestSubmitted, setRequestSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // ✅ On page reload, restore submitted state
  useEffect(() => {
    const stored = localStorage.getItem("shiftExtensionRequestSubmitted");
    if (stored === "true") {
      setRequestSubmitted(true);
    }
  }, []);

  const handleRequestExtend = () => {
    if (requestSubmitted) return; // prevent reopening if already submitted
    setModalOpen(true);
    setAlertClose(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setAlertClose(false); // reset, so alert can show again if canceled
  };

  const handleSubmitExtension = (extensionData) => {
    const user = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const shiftType = localStorage.getItem("shiftType") ?? '';
    const userShiftStartTime = localStorage.getItem("shiftStartTime") ?? '';
    const userShiftEndTime = localStorage.getItem("shiftEndTime") ?? '';

    const { extendedStart, extendedEnd, reason } = extensionData;

    if (isEmpty(extendedStart) || isEmpty(extendedEnd) || isEmpty(reason)) {
      toast.error("Please fill all.", { autoClose: 3000 });
      return;
    }
    setIsLoading(true); // ✅ set loading state
    const payload = {
      "user_id": userId,
      "shiftType": JSON.parse(shiftType),
      "current_start_time": JSON.parse(userShiftStartTime),
      "current_end_time": JSON.parse(userShiftEndTime),
      "requested_start_time": extendedStart,
      "requested_end_time": extendedEnd,
      "reason": reason,
      "auto_trigger": true,
    };

    callApi("POST", "shift_extension_request.php", payload)
      .then(res => res.data)
      .then(response => {
        if (response.success) {
          toast.success(response.message, { autoClose: 3000 });
          setModalOpen(false);
          setRequestSubmitted(true);
          localStorage.setItem("shiftExtensionRequestSubmitted", "true"); // ✅ persist
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch(err => {
        console.log(err);
        this.setState({ isLoading: false });
      }).finally(() => {
        setIsLoading(false); // ✅ reset loading state
      });
  };

  return (
    <>
      <ShiftExtensionAlert
        shiftEndTime={userShiftEndTime}
        close={alertClose}
        requestSubmitted={requestSubmitted} // ✅ don’t show alert if already submitted
        onRequestExtend={handleRequestExtend}
      />
      <ShiftExtensionRequestModal
        show={modalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitExtension}
        currentShiftEnd={userShiftEndTime}
        loading={isLoading} // ✅ pass loading state
      />
    </>
  );
}
